<template>
  <v-container
    grid-list-lg
    fill-height
  >
    <v-layout
      v-if="componentLoading"
      row
      wrap
      justify-center
    >
      <v-progress-circular
        :size="64"
        :width="3"
        indeterminate
        color="primary"
      />
    </v-layout>
    <v-layout
      v-else
      row
      wrap
      justify-center
    >
      <v-flex class="max-maxWidth">
        <v-card
          id="appSettingsContent"
          class="max-shadow"
        >
          <v-card-text>
            <v-container
              grid-list-lg
              fluid
              class="pa-2"
            >
              <v-layout column>
                <v-flex>
                  <toggle
                    v-model="miscSettings.returning_visitors"
                    :disabled="disabled"
                    title="Returning Visitors"
                    caption="Allow returning visitors for faster checkin"
                  />
                </v-flex>
                <v-flex>
                  <toggle
                    v-model="miscSettings.self_checkout"
                    :disabled="disabled"
                    title="Self Checkout"
                    caption="Allow visitors to check themselves out"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import toggle from '@/components/common/Toggle';
import _get from 'lodash/get';
import { database } from '@/firebase';

export default {
  name: 'MiscSettings',
  components: {
    toggle
  },
  data() {
    return {
      disabled: false,
      miscSettings: {},

      componentLoading: true
    };
  },
  computed: {
    miscRef() {
      const lid = _get(this.$store.state.VMS, 'lid');
      // return null if the location ID is not yet set
      if (!lid) return null;

      return database.ref(`vms/${lid}/settings/app_settings/misc_settings`);
    }
  },
  watch: {
    miscRef: {
      handler(val) {
        if (!val) return;
        this.fetchSettings();
      },
      immediate: true
    },
    miscSettings: {
      handler(val) {
        this.miscRef.update(val);
      },
      deep: true
    }
  },
  created() {
    this.$store.commit('setToolbarTitle', { toolbarTitle: 'App Settings' });
  },
  methods: {
    fetchSettings() {
      this.miscRef.once('value').then(notificationSnapshot => {
        if (!notificationSnapshot) return;
        this.componentLoading = false;
        const notification = notificationSnapshot.val();
        if (notification) {
          this.miscSettings = notification;
        }
      });
    }
  }
};
</script>
<style>
/* #appSettingsContent {
  height: calc(100vh - var(--toolbar-height));
  overflow-y: scroll;
} */
#appSettingsContent .settingHeight {
  height: 30px !important;
}
</style>
